import { Component, OnInit } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { BomDataHelper, CATEGORY } from '../../services/helpers/bom-data-helper';
import { CustomerService } from '../../services/customer.service';
import { environment } from '../../../environments/environment';
import { CurrentService } from '../../services/current.service';
import { ProcessQuoteService } from '../../services/process-quote.service';
import { PrintService } from '../../services/print.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ng-casto-installation-quote',
  templateUrl: './installation-quote.component.html',
})
export class InstallationQuoteComponent implements OnInit {
  public flattenBom: any;
  public beautifiedBom: any;

  public installationPrice: number = 0;
  public installationAppliancePrice: number = 0;
  public shippingPrice: number = 0;
  public kitchenTva10: number = 0;
  public applianceTva20: number = 0;

  public customerInfos: any;
  public projectName: string;

  public vendorEnvironment: boolean;
  public projectIsSaved: boolean;
  public printLoading: boolean;

  constructor(
    public modalService: ModalService,
    public customer: CustomerService,
    public processQuote: ProcessQuoteService,
    public current: CurrentService,
    private print: PrintService,
    private translate: TranslateService
  ) {
    this.customerInfos = {
      name: customer.isLogged ? customer.fullName : '(non identifié)',
      id: customer.isLogged ? customer.userDatas.id : '-',
    };

    this.vendorEnvironment = environment.vendor;
    this.projectIsSaved = current.HBMProject;
    this.beautifiedBom = BomDataHelper.extractBlockGroupedProductsList(modalService.currentDatas.bom);

    this.beautifiedBom.totalByCategories.map(cat => {
      if (cat.key == CATEGORY.APPLIANCES) {
        this.applianceTva20 += cat.price;
      } else {
        this.kitchenTva10 += (cat.price / 1.2) * 1.1;
      }
    });

    switch (true) {
      case this.applianceTva20 + this.kitchenTva10 >= 3000:
        this.shippingPrice = 169;
        break;

      case this.applianceTva20 + this.kitchenTva10 >= 1000:
        this.shippingPrice = 129;
        break;

      default:
        this.shippingPrice = 99;
        break;
    }
  }

  back(): void {
    this.modalService.display(MODAL.PRODUCTS_LIST, {
      bom: this.modalService.currentDatas.bom,
    });
  }

  ngOnInit(): void {}

  order() {
    this.modalService.display(MODAL.ORDER_PRODUCTS, {
      bom: this.modalService.currentDatas.bom,
    });
  }

  close() {
    this.modalService.close();
  }

  printList() {
    this.printLoading = true;

    this.print.reset();
    this.print
      .addHeader(this.translate.instant('popins.installation.print_title_' + this.customer.context))
      .then(() => {
        if (this.customer.isLogged) {
          this.print.addText(
            this.translate.instant('popins.products_list.customer_id') + ' ' + this.customerInfos.id,
            'my-3'
          );
          this.print.addText(
            this.translate.instant('popins.products_list.name') + ' ' + this.customerInfos.name,
            'my-3'
          );
        }

        this.print.addText(
          this.translate.instant('popins.products_list.project') +
            ' ' +
            (this.current.HBMProject
              ? this.current.HBMProject.name
              : this.translate.instant('popins.price_info.placeholder_project_' + this.customer.context)),
          'my-3'
        );

        let _rightNow = new Date();
        let _dateStr = _rightNow.toISOString().slice(0, 10).split('-');
        this.print.addText('Le ' + _dateStr[2] + '/' + _dateStr[1] + '/' + _dateStr[0], 'mt-3 mb-5');

        let _titleDiv = document.createElement('div');
        _titleDiv.className = 'installation-title';
        _titleDiv.innerHTML = this.translate.instant('popins.installation.title');
        this.print.addDiv(_titleDiv).then(() => {
          this.print
            .addDiv(document.querySelector('.installation-quote').cloneNode(true) as HTMLDivElement)
            .then(() => {
              this.print.addText('', 'mt-5');
              this.print.addDiv(document.querySelector('.legacy').cloneNode(true) as HTMLDivElement).then(() => {
                this.print.print();
                this.printLoading = false;
              });
            });
        });
      });
  }
}
